import {Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {QuestionTextProps} from './QuestionText.types';

export const QuestionText = ({description, text}: QuestionTextProps) => (
  <div className={sprinkles({flex: 'flex', dir: 'col', gap: [16, 24]})}>
    <Text variant="heading2" color="burgundy">
      {text}
    </Text>

    {description && <Text color="doveGray">{description}</Text>}
  </div>
);
